import { Tooltip } from '@design';
import { EllipsisDetector } from '@terminal/components/ellipsis-detector/EllipsisDetector';
import { ReactNode } from 'react';
import styles from './CatalystBadge.module.scss';

export type CatalystBadgeProps = {
  logo: ReactNode;
  name: string;
  onClick: VoidFunction;
  trailing?: ReactNode;
  tooltipLabel?: string;
};

export const CatalystBadge = ({
  logo,
  name,
  trailing,
  onClick,
  tooltipLabel,
}: CatalystBadgeProps) => {
  return (
    <Tooltip label={tooltipLabel} hasDelay={false}>
      <div
        aria-role="button"
        aria-label={name}
        onClick={onClick}
        className={styles.root}
      >
        {logo}

        <EllipsisDetector label={name} placement="bottom" inPortal>
          <span className={styles.name}>{name}</span>
        </EllipsisDetector>
        {trailing}
      </div>
    </Tooltip>
  );
};
